module.exports = __webpack_public_path__ + "static/media/li.3b4d27bf.png";